import { AssetClassLandAreaComponentModel } from '../../asset_class';
import {BaseModel} from '../../_base/crud';
import { AcSource } from './ac-source.model';

export class AssetClassTenure extends BaseModel {
    id: number;
    ac_id: number;
    ac_type_id: number;

    tenure: string;

    currency: string;
    rent_type: string;
    total_consideration: number;

    rent_review: number;
    rent_review_comment: string;
    lease_duration: number;
    unexpired_lease_term: number;
    write_off_period: number;
    break_option: number;
    rent_free_period: number;
    fitting_out_period: number;
    cap_payment: number;


    inclusive_property_management: string;
    estimated_amount_property_management: number;

    consideration_inclusive_cost: string;
    estimated_amount_utilities_cost: number;

    consideration_full_repair_cost: string;
    estimated_amount_repair_cost: number;

    conversion: {
        id?: number,
        quote_currency: string,
        exchange_rate: number;
    }[];

    source: AcSource;
    additional: AcLandTenure[];

    formType: number;

    created_at: Date;
    updated_at: Date;
    deleted_at: Date;

    clear() {
        this.id = undefined;

        this.ac_id = undefined;
        this.ac_type_id = undefined;

        this.tenure = '';

        this.total_consideration = undefined;

        this.rent_type = 'headline';
        this.rent_review = undefined;
        this.rent_review_comment = '';
        this.lease_duration = undefined;
        this.unexpired_lease_term = undefined;
        this.write_off_period = undefined;
        this.break_option = undefined;
        this.rent_free_period = undefined;
        this.fitting_out_period = undefined;
        this.cap_payment = 0;

        this.inclusive_property_management = 'yes';
        this.estimated_amount_property_management = undefined;
        this.consideration_inclusive_cost = 'yes';
        this.estimated_amount_utilities_cost = undefined;
        this.consideration_full_repair_cost = 'yes';
        this.estimated_amount_repair_cost = undefined;
        this.currency = 'MNT';

        this.source = new AcSource();
        this.source.clear();
        this.additional = [];

        this.formType = 2;

        this.created_at = new Date();
        this.updated_at = new Date();
        this.deleted_at = null;
    }
}

export class PropertyTenure {
    id: number;
    ref_id: number;

    tenure: string;

    currency: string;
    rent_type: string;
    total_consideration: number;

    rent_review: number;
    rent_review_comment: string;
    lease_duration: number;
    unexpired_lease_term: number;
    write_off_period: number;
    break_option: number;
    rent_free_period: number;
    fitting_out_period: number;
    cap_payment: number;


    inclusive_property_management: string;
    estimated_amount_property_management: number;

    consideration_inclusive_cost: string;
    estimated_amount_utilities_cost: number;

    consideration_full_repair_cost: string;
    estimated_amount_repair_cost: number;

    created_at: Date;
    updated_at: Date;
    deleted_at: Date;

    clear() {
        this.id = undefined;

        this.ref_id = undefined;

        this.tenure = '';

        this.total_consideration = undefined;

        this.rent_type = 'headline';
        this.rent_review = undefined;
        this.rent_review_comment = '';
        this.lease_duration = undefined;
        this.unexpired_lease_term = undefined;
        this.write_off_period = undefined;
        this.break_option = undefined;
        this.rent_free_period = undefined;
        this.fitting_out_period = undefined;
        this.cap_payment = 0;

        this.inclusive_property_management = 'yes';
        this.estimated_amount_property_management = undefined;
        this.consideration_inclusive_cost = 'yes';
        this.estimated_amount_utilities_cost = undefined;
        this.consideration_full_repair_cost = 'yes';
        this.estimated_amount_repair_cost = undefined;
        this.currency = 'MNT';

        this.created_at = new Date();
        this.updated_at = new Date();
        this.deleted_at = null;
    }
}

export class AcConsideration {
    id: number;
    pTenure: PropertyTenure;
    source: AcSource;
    additional: {
        tenure: AcLandTenure,
        included: boolean
    }[];

    clear() {
        this.id = undefined;
        this.pTenure = new PropertyTenure();
        this.pTenure.clear();

        this.source = new AcSource();
        this.source.clear();
        this.additional = [];
    }
}

export class AcLandTenure {
    id: number;
    com_order: number;
    included: boolean;

    land_tenure_id: number;
    land_tenure_name: string;
    tenure_length: number;
    currency: string;
    consideration: number;

    created_at: Date;
    updated_at: Date;

    clear() {
        this.id = undefined;
        this.com_order = undefined;
        this.included = true;
        this.land_tenure_id = null;
        this.land_tenure_name = '';
        this.tenure_length = 0;
        this.currency = '';
        this.consideration = 0;

        this.created_at = new Date();
        this.updated_at = new Date();
    }
}